import { render, staticRenderFns } from "./AnimationLoadingWhale.vue?vue&type=template&id=3d2a3c98&scoped=true&"
import script from "./AnimationLoadingWhale.vue?vue&type=script&lang=js&"
export * from "./AnimationLoadingWhale.vue?vue&type=script&lang=js&"
import style0 from "./AnimationLoadingWhale.vue?vue&type=style&index=0&id=3d2a3c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2a3c98",
  null
  
)

export default component.exports